import { Component, HostListener } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { GoogleAnalyticsService } from "./main/services/google-analytics.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  showWhatsAppFab: boolean = false;
  constructor(
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}

  ngOnInit() {
    // Event snippet for כניסה לאתר conversion page
    this.googleAnalyticsService.tagEmitter(
      "event",
      "conversion",
      "AW-10808009432/AFGSCJSo5psYENjF1KEo"
    );
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    try {
      const yOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.showWhatsAppFab = yOffset > 200;
    } catch {
      this.showWhatsAppFab = false;
    }
  }
}
